let config = require('../data/config.json');

export class AppConfig {
  public static title = "OneClick.Community";
  public static icon = "/navbar-icon.png";
  public static logo = "/logo.png";
  public static mobile = null;
  public static private = false;

  public static theme = null;
  public static community = null;

  public static pages = config.pages;
  public static themes = config.themes;
  public static icons = config.icons;
  public static fonts = config.fonts;
  public static palettes = config.palettes;
  public static styles = config.styles;
  public static menu = config.menu.main;

  public static setCommunity(community:any) {
    AppConfig.community = community;
    AppConfig.title = community.name;
    AppConfig.icon = community.icon;
    AppConfig.logo = community.logo ? community.logo : '/logo-default.png';
    AppConfig.theme = community.theme;
    AppConfig.mobile = community.mobile;
    AppConfig.menu = config.menu.community;
    AppConfig.update();
  }

  public static update() {
    document.title = AppConfig.title;

    let favicon:any = document.querySelector('[rel=icon]');
    if(favicon)
      favicon.href = AppConfig.icon;

    if(AppConfig.theme) 
      AppConfig.applyTheme(AppConfig.theme.palette, AppConfig.theme.styles);
  }

  public static applyTheme(palette:string[], styles:any) {
    let font = styles['body-font'];

    if(font && AppConfig.fonts.indexOf(font) == -1) {
      let fontLink = document.getElementById('GoogleFontLink') as HTMLLinkElement;
      fontLink.href = `https://fonts.googleapis.com/css?family=${font}`;
    }

    let style = document.documentElement.style
    let properties = Object.keys(styles);
    for(let i = 0; i < properties.length; i++) {
      let value = styles[properties[i]];
      if(typeof value == 'number') {
        let color = palette[value];
        if(color == undefined) 
          value = 'black';
        else
          value = color;
      }
      style.setProperty('--' + properties[i], value);
    }

    let scale = styles['body-font-scale'];
    let newScale = +scale.substring(0, scale.length-1);
    newScale += 20;
    style.setProperty('--quill-font-scale', newScale + '%');
  }
}
